import { useEffect, useRef } from "react";
import { track, CALENDLY_THANK_YOU } from "@/lib/analytics";

const WIDGET_SRC = "https://assets.calendly.com/assets/external/widget.js";

function loadCalendlyScript() {
  return new Promise((resolve) => {
    if (window.Calendly) return resolve();
    let s = document.querySelector(`script[src="${WIDGET_SRC}"]`);
    if (s) {
      s.addEventListener("load", () => resolve());
      if (window.Calendly) resolve();
      return;
    }
    s = document.createElement("script");
    s.src = WIDGET_SRC;
    s.async = true;
    s.onload = () => resolve();
    document.body.appendChild(s);
  });
}

const isCalendlyEvent = (e) =>
  e.data && typeof e.data.event === "string" && e.data.event.indexOf("calendly") === 0;

export default function CalendlyEmbed({ url, prefill = {}, trackingValue }) {
  const containerRef = useRef(null);

  useEffect(() => {
    let mounted = true;
    loadCalendlyScript().then(() => {
      if (mounted && window.Calendly && containerRef.current) {
        containerRef.current.innerHTML = "";
        window.Calendly.initInlineWidget({
          url,
          parentElement: containerRef.current,
          prefill,
        });
      }
    });

    const onMessage = (e) => {
      if (!isCalendlyEvent(e)) return;
      if (e.data.event === "calendly.event_scheduled") {
        track("Salon_Calendly_booked", {
          currency: "AUD",
          value: trackingValue || 0,
        });
        // Send them to the branded thank-you page (also tracked there)
        window.location.href = CALENDLY_THANK_YOU;
      }
    };
    window.addEventListener("message", onMessage);

    return () => {
      mounted = false;
      window.removeEventListener("message", onMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return (
    <div
      ref={containerRef}
      data-testid="calendly-embed"
      style={{ minWidth: "320px", height: "700px", position: "relative" }}
    />
  );
}
